




















import AnimatedNumber from './animated_number'

export default {
  components: { AnimatedNumber }
  props: {
    title: { default: 'Rankings' },
    icon: { default: 'mdi-star' },
    items: { default: [{ id: 'uuid', text: 'name', score: '0' }] },
    animated: { type: Boolean, default: false },
    currency: { type: Boolean, default: false }
  }
}
